import { defineComponent as _defineComponent } from 'vue'
import useGsap from '../../../../composables/useGsap';
import { CdnImg } from '@webplatform/cdn-image';
import { ref, onMounted } from 'vue-demi';
import { AbSection, AbContainer, AbTitle, AbDescription } from '../../../ui';
import UiParallelogram from '../../../canyon/ui/UiParallelogram.vue';
import { Spacing } from '../../../../helpers/shared-props';

interface FeatureSectionBannerItem {
  image?: {
    path?: string;
    alt?: string;
  };
  text: string;
}
interface Props {
  data: {
    id?: string;
    parts?: FeatureSectionBannerItem[];
    title?: string;
    spacing?: Spacing;
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionBanner',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: {
    id?: string;
    parts?: FeatureSectionBannerItem[];
    title?: string;
    spacing?: Spacing;
  };
};


const section = ref<any>(null);
const { gsap, ScrollTrigger } = useGsap();

onMounted(() => {
  if (!props.data.parts || props.data.parts.length < 2) return;
  if (!section.value || !section.value.$el) return;
  if (gsap && ScrollTrigger) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section.value.$el,
        start: 'center+=500 center',
        toggleActions: 'restart none none reverse',
      },
      defaults: { ease: 'none' },
    });

    tl.fromTo(
      section.value.$el.querySelector('.image1'),
      { opacity: 1, y: 0 },
      { opacity: 0, y: -20 },
    )
      .fromTo(
        section.value.$el.querySelector('.image2'),
        { opacity: 0, scaleX: 0.95, scaleY: 0.95, y: 20 },
        { opacity: 1, scaleX: 1, scaleY: 1, y: 0 },
      )

      .fromTo(
        section.value.$el.querySelector('.text1'),
        { opacity: 1, y: 0 },
        { opacity: 0, y: -20 },
        0,
      )
      .fromTo(
        section.value.$el.querySelector('.text2'),
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0 },
        0.5,
      );

    // // Pagination

    gsap.fromTo(
      section.value.$el.querySelector(
        '.pagination-bullet1 .pagination-progress',
      ),
      { height: 0 },
      {
        height: '100%',
        scrollTrigger: {
          trigger: section.value.$el,
          start: 'center center',
          end: '+=500',
          scrub: true,
          toggleActions: 'restart none none reverse',
        },
      },
    );

    gsap.fromTo(
      section.value.$el.querySelector(
        '.pagination-bullet2 .pagination-progress',
      ),
      { height: 0 },
      {
        height: '100%',
        scrollTrigger: {
          trigger: section.value.$el,
          start: 'center+=500 center',
          end: '+=500',
          scrub: true,
          toggleActions: 'restart none none reverse',
        },
      },
    );

    ScrollTrigger.create({
      trigger: section.value.$el,
      start: 'center center',
      end: '+=1000',
      pin: true,
      anticipatePin: 1,
    });
  }
});

return { __sfc: true,props, section, gsap, ScrollTrigger, CdnImg, AbSection, AbContainer, AbTitle, AbDescription, UiParallelogram }
}

})